import React from 'react';

import StopLoad from '../StopLoad';
import ShipperOrderRow from '../ShipperOrderRow';

const AggregatedLoadRow = ({ className, stop, shipperOrdersSkin = {}, item }) => {
  const shipperOrders = stop?.shipper_orders || [];
  const reference_number = stop
    ? [...(stop.load_pickup || []), ...(stop.load_dropoff || [])].reduce(
        (p, n) => ({ ...p, ...n }),
        []
      ).reference_number
    : '';

  return (
    <div className={className}>
      <StopLoad
        type_pallets={stop?.type_pallets}
        real_pallets={stop?.real_pallets}
        total_weight={stop?.total_weight}
        item_height={stop?.item_height}
        equivalent_pallets={stop?.equivalent_pallets}
        showCustomMeasures={false}
        reference_number={reference_number}
        stop={stop}
        extraClassName="stop-load--aggregated bold-load"
      />

      {shipperOrders.map((shipperOrder, key) => {
        const shipperOrderDetails =
          item?.shipper_orders?.find(
            (shipperOrderDetail) => shipperOrderDetail.id === shipperOrder.id
          ) || [];
        return (
          <ShipperOrderRow
            key={shipperOrder.id}
            shipperOrderId={shipperOrder.id}
            shipperOrder={{ ...shipperOrder, ...shipperOrderDetails }}
            shipperOrdersSkin={shipperOrdersSkin}
            isStore={!!stop?.store}
            isLast={key === shipperOrders?.length - 1}
            currentStop={stop}
            isXdockJourney={item?.has_xdock_shipper_order}
          />
        );
      })}
    </div>
  );
};

export default AggregatedLoadRow;
